const carouselItems = [
  {
    title: '热血巅峰·斗破苍穹',
    desc: '三十年河东三十年河西，莫欺少年穷！萧炎的传奇修炼之路，从废柴到斗帝的逆袭史诗。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20manga%20scene%20with%20a%20young%20warrior%20surrounded%20by%20flames%20and%20energy%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20golden%20tones%2C%20action%20pose%2C%20clean%20simple%20gradient%20background%2C%20horizontal%20banner%20format&width=800&height=500&seq=carousel-doupo&orientation=landscape',
    tag: '玄幻',
  },
  {
    title: '武魂觉醒·斗罗大陆',
    desc: '唐三携前世记忆穿越斗罗大陆，双生武魂觉醒，踏上封号斗罗的荣耀之路。',
    img: 'https://readdy.ai/api/search-image?query=Martial%20arts%20fantasy%20manga%20illustration%20with%20a%20hero%20activating%20blue%20and%20golden%20spirit%20rings%2C%20dynamic%20energy%20effects%2C%20warm%20peach%20and%20cream%20background%2C%20Chinese%20xianxia%20style%2C%20horizontal%20banner&width=800&height=500&seq=carousel-douluo&orientation=landscape',
    tag: '热血',
  },
  {
    title: '异人世界·一人之下',
    desc: '普通大学生张楚岚卷入异人世界，揭开爷爷留下的惊天秘密，现代与传统的碰撞。',
    img: 'https://readdy.ai/api/search-image?query=Urban%20fantasy%20manga%20scene%20with%20supernatural%20martial%20arts%20in%20a%20modern%20city%20setting%2C%20mystical%20energy%20effects%2C%20warm%20golden%20and%20coral%20tones%2C%20stylish%20character%2C%20horizontal%20banner&width=800&height=500&seq=carousel-yiren&orientation=landscape',
    tag: '奇幻',
  },
  {
    title: '独断万古·完美世界',
    desc: '石昊生于大荒，以无敌之姿横推万古诸敌，缔造属于自己的完美世界传说。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20manga%20scene%20with%20a%20young%20hero%20on%20a%20mountain%20peak%20facing%20celestial%20beings%2C%20dramatic%20clouds%20and%20golden%20light%2C%20warm%20sunset%20tones%2C%20horizontal%20banner&width=800&height=500&seq=carousel-wanmei&orientation=landscape',
    tag: '玄幻',
  },
  {
    title: '硬核武侠·镖人',
    desc: '隋末乱世，镖客刀马行走江湖。天下熙熙皆为利来，天下攘攘皆为利往。',
    img: 'https://readdy.ai/api/search-image?query=Gritty%20historical%20Chinese%20manga%20scene%20with%20a%20lone%20swordsman%20on%20horseback%20in%20a%20desert%2C%20ink%20wash%20painting%20style%2C%20warm%20earthy%20sepia%20tones%2C%20dramatic%20composition%2C%20horizontal%20banner&width=800&height=500&seq=carousel-biaoren&orientation=landscape',
    tag: '武侠',
  },
  {
    title: '凡人修仙·韩立传奇',
    desc: '一个普通的山村少年，凭借坚定意志踏上修仙之路，凡人亦可逆天改命。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manga%20scene%20with%20a%20cultivator%20in%20traditional%20robes%20meditating%20under%20a%20ancient%20tree%2C%20spiritual%20energy%20flowing%2C%20soft%20warm%20golden%20light%2C%20peaceful%20atmosphere%2C%20horizontal%20banner&width=800&height=500&seq=carousel-fanren&orientation=landscape',
    tag: '修仙',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">精选热门漫画专题，深度探索精彩故事世界</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div key={i} className="group relative bg-background-100 rounded-2xl overflow-hidden cursor-pointer">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}